"use client"

import { calculateTextSize, cn } from "@/lib/utils"
import { useEffect, useState } from "react"

export default function FeaturedPostFallbackCoverImage({
  title,
  className,
  minFontSize = 24,
  maxFontSize = 32,
}: {
  title: string
  className?: string
  minFontSize?: number
  maxFontSize?: number
}) {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) return null

  return (
    <div className="w-full h-full flex items-center justify-center rounded-lg">
      <span
        className={cn(
          "text-foreground text-center line-clamp-3 font-header break-words",
          className
        )}
        style={{
          fontSize: calculateTextSize(title, {
            minFontSize: minFontSize,
            maxFontSize: Number(
              className?.match(/\[(\d+)px\]/)?.[1] || maxFontSize
            ),
          }),
        }}
      >
        {title}
      </span>
    </div>
  )
}
